<template>
  <v-card-text class="row">
    <img class="col-4" src="@/assets/images/undraw_mail.svg" />

    <div class="col-8">
      <div class="d-flex justify-space-between">
        <h3 class="black--text font-weight-medium">
          {{ notification.titulo }}
        </h3>
        <v-icon v-if="notification.estado == 'ACTIVA'" color="warning"
          >mdi-clock-outline</v-icon
        >
        <v-icon v-else color="success"
          >mdi-checkbox-marked-circle-outline</v-icon
        >
      </div>
      <div class="text-start" v-html="notification.contenido"></div>
      <div class="d-flex justify-space-between">
        <v-btn
          v-if="notification.estado == 'ACTIVA'"
          @click="ActionChangeState(notification.idNotificacion)"
          x-small
          color="light"
          elevation="0"
        >
          <span class="primary--text">Activa</span>
        </v-btn>
        <div v-if="notification.estado == 'VISTA'">
          <v-icon color="success">mdi-check-all</v-icon>
          <span class="success--text">Vista</span>
        </div>
        <span>{{ notification.fechaNotificacion | hour }}</span>
      </div>
    </div>
  </v-card-text>
</template>

<script>
import {
  NOTIFICATIONS_M,
  ACTION_CHANGE_STATE_NOTIFICATION
} from "@/shared/components/notifications/store/types.js";
import { mapActions } from "vuex";
export default {
  name: "notification",
  props: {
    notification: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions({
      ActionChangeState: `${NOTIFICATIONS_M}${ACTION_CHANGE_STATE_NOTIFICATION}`
    })
  },
};
</script>

<style>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Amsi Pro',  sans-serif;
}

</style>